// Avisos push de la web (Chrome en Android y compu; en iPhone, solo con la app agregada a
// la pantalla de inicio, iOS 16.4 o más nuevo). La app de Android/iOS usa Firebase (native.js).
// tipo: 'usuario' (mensajes, conexiones, regalos) o 'comercio' (compras, pedidos, códigos).
import { api } from './api';
import { isNativeApp } from './native';
import { abiertaComoApp } from './instalarWeb';

const RUTAS = {
  usuario: { guardar: '/push/web', borrar: '/push/web/borrar' },
  comercio: { guardar: '/comercio/push', borrar: '/comercio/push/borrar' },
};

const esIphone = () => /iphone|ipad|ipod/i.test(navigator.userAgent || '')
  || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

const soportado = () => !isNativeApp() && typeof window !== 'undefined'
  && 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;

// 'activo' | 'pendiente' (falta pedir permiso) | 'denegado' | 'instalar' (iPhone: primero agregar al inicio) | 'no'
export function estadoAvisos() {
  if (isNativeApp()) return 'no';
  if (esIphone() && !abiertaComoApp()) return 'instalar';
  if (!soportado()) return 'no';
  if (Notification.permission === 'granted') return 'activo';
  if (Notification.permission === 'denied') return 'denegado';
  return 'pendiente';
}

const b64aBytes = (b64) => {
  const s = atob((b64 + '='.repeat((4 - (b64.length % 4)) % 4)).replace(/-/g, '+').replace(/_/g, '/'));
  return Uint8Array.from(s, (c) => c.charCodeAt(0));
};

async function suscripcion(crear) {
  const reg = (await navigator.serviceWorker.getRegistration('/')) || (await navigator.serviceWorker.register('/service-worker.js'));
  await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub && crear) {
    const { clave } = await api.get('/push/web/clave');
    // Si el servicio de avisos del navegador no responde, no dejar el botón trabado
    const espera = new Promise((_, no) => setTimeout(() => no(new Error('El navegador no respondió. Probá de nuevo.')), 20000));
    sub = await Promise.race([reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64aBytes(clave) }), espera]);
  }
  return sub;
}

// Pide permiso (tiene que llamarse al tocar un botón: iPhone no deja pedirlo solo) y registra el celular.
// Devuelve el estado final.
export async function activarAvisos(tipo) {
  if (!soportado()) return estadoAvisos();
  const permiso = await Notification.requestPermission();
  if (permiso !== 'granted') return estadoAvisos();
  const sub = await suscripcion(true);
  await api.post(RUTAS[tipo].guardar, { suscripcion: sub.toJSON() });
  return 'activo';
}

// Con el permiso ya dado: volver a registrar el celular en silencio (al ingresar o al abrir la app).
export async function sincronizarAvisos(tipo) {
  if (!soportado() || Notification.permission !== 'granted') return;
  try {
    const sub = await suscripcion(true);
    if (sub) await api.post(RUTAS[tipo].guardar, { suscripcion: sub.toJSON() });
  } catch (e) { console.warn('[avisos]', e?.message); }
}

// Al cerrar sesión: este celular deja de recibir los avisos de esa cuenta
export async function quitarAvisos(tipo) {
  if (!soportado() || Notification.permission !== 'granted') return;
  try {
    const sub = await suscripcion(false);
    if (sub) await api.post(RUTAS[tipo].borrar, { endpoint: sub.endpoint });
  } catch { /* igual se cierra la sesión */ }
}
